var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-helper-components-2-header"},[_c('DigitalCurrency8WatchVideoIntroduction'),_c('DigitalCurrency13DigitalCurrencyFeatureList',{staticClass:"mt-10"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }